import React, { forwardRef } from "react";

import { IExpander } from "./ExpanderInterface";
import { StyledExpandSingle } from "./Styles";

export const ExpandSingle = forwardRef<
  SVGSVGElement,
  IExpander & React.ComponentPropsWithoutRef<"svg">
>(({ expanded = false, ...rest }, ref) => {
  return (
    <StyledExpandSingle
      ref={ref}
      viewBox="0 0 24 24"
      $expanded={expanded}
      {...rest}
    >
      <path
        d="M15.372 14.736a.993.993 0 001.349 0 .867.867 0 000-1.275L12 9l-4.72 4.461a.867.867 0 000 1.275.993.993 0 001.348 0L12 11.549l3.372 3.187z"
        fillRule="nonzero"
      />
    </StyledExpandSingle>
  );
});

ExpandSingle.displayName = "ExpandSingle";
